import { DateTime } from "luxon";

export const SQL_DATE_FORMAT = "yyyy-MM-dd";
export const SQL_DATE_TIME_FORMAT = "yyyy-MM-dd HH:mm:ss";
export const HTML_DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";
export const HTML_DATE_FORMAT = "yyyy-MM-dd";

export function fromSqlDateTime(str) {
    return DateTime.fromSQL(str, { zone: "utc" }).toLocal();
}

export function fromNow() {
    return DateTime.now().toLocal();
}

export function fromString(str, format = null) {
    if (typeof str !== "string") {
        return str;
    }

    if (str.toLowerCase() === "now") {
        return fromNow();
    }

    if (format !== null) {
        return DateTime.fromFormat(str, format, { zone: "utc" }).toLocal();
    }

    if (/\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(str)) {
        return fromSqlDateTime(str, { zone: "utc" }).toLocal();
    }

    if (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str)) {
        return DateTime.fromISO(str);
    }

    if (/\d{4}-\d{2}-\d{2}/.test(str)) {
        return fromSqlDateTime(str.concat(" 00:00:00")).toLocal();
    }
    return DateTime.fromISO(str);
}

export function fromLocalString(str, format = null) {
    if (typeof str !== "string") {
        return str;
    }

    if (str.toLowerCase() === "now") {
        return fromNow();
    }

    if (format !== null) {
        return DateTime.fromFormat(str, format, { zone: "system" });
    }

    if (/\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(str)) {
        return fromSqlDateTime(str, { zone: "system" });
    }

    if (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str)) {
        return DateTime.fromISO(str);
    }

    if (/\d{4}-\d{2}-\d{2}/.test(str)) {
        return fromSqlDateTime(str.concat(" 00:00:00"));
    }
    return DateTime.fromISO(str);
}
